import React from 'react';

/**
 * Page representing an agent's Activities.
 */
export const Activities = () => {
  return (
    <div>
      <h2>My Book</h2>
    </div>
  );
};
